import { Locale } from '@synergy/models';
import poolConfig from 'pool.config.json';

import { PoolConfig } from './models/pool-config';
import { PoolInstance, isInstance } from './pool-instance';

if (!process.env['NX_PUBLIC_APP_API_BASE_URL'] && process.env['NODE_ENV'] !== 'test') {
    throw new Error('NX_PUBLIC_APP_API_BASE_URL environment variable missing');
}

export const BASE_URL = process.env['NX_PUBLIC_URL'] ?? '/';
export const CUSTOMER_BASE_URL = process.env['NX_PUBLIC_APP_CUSTOMER_URL'] ?? '/';
export const SUPPLIER_BASE_URL = process.env['NX_PUBLIC_APP_SUPPLIER_URL'] ?? '/';
export const APP_DOMAIN: string =
    process.env['NX_PUBLIC_APP_DOMAIN'] || window.location.protocol + '//' + window.location.host;
export const API_BASE_URL: string = APP_DOMAIN + (process.env['NX_PUBLIC_APP_API_BASE_URL'] ?? '');
export const SENTRY_DSN = process.env['NX_PUBLIC_APP_SENTRY_DSN'] || undefined;
export const COMMANDBAR_CUSTOMERID = process.env['NX_PUBLIC_APP_COMMANDBAR_CUSTOMERID'] || undefined;
export const ENVIRONMENT = process.env['NX_PUBLIC_APP_ENVIRONMENT'] || undefined;
export const RELEASE = process.env['NX_PUBLIC_APP_RELEASE'] || undefined;
export const LOGOUT_URL: string = process.env['NX_PUBLIC_APP_LOGOUT_URL'] || '';
export const LOGIN_URL: string = process.env['NX_PUBLIC_APP_LOGIN_URL'] || '';
export const DEFAULT_REDIRECT_URL: string = process.env['NX_PUBLIC_APP_DEFAULT_REDIRECT_URL'] || '';
export const SHOP_URL =
    process.env['NX_PUBLIC_APP_SHOP_URL'] ||
    `${window.location.protocol}//${process.env['NX_PUBLIC_APP_DOMAIN_PREFIX']}shop.${process.env['NX_PUBLIC_APP_BASE_DOMAIN']}`;
export const MAX_FILE_SIZE = 5242880; // 5MB
export const IMAGE_CACHE_RESOLVE = 'synergy/image-cache/resolve';

export const defaultPageSize = 50;
export const defaultLocale = Locale.German;

export const APP_POOL_CONFIG: PoolConfig = poolConfig as PoolConfig;
